<template>
<div class="card rounded-0 box-shadow-sm bg-light mx-auto pb-3 pb-sm-0" style="max-width: 700px">
  <div class="steps steps-light">
    <a class="step-item active">
      <div class="step-progress">
        <span class="step-count"><i class="czi-check"></i></span>
      </div>
    </a>
    <a class="step-item active">
      <div class="step-progress">
        <span class="step-count"><i class="czi-check"></i></span>
      </div>
    </a>
    <a class="step-item current">
      <div class="step-progress">
        <span class="step-count">3</span>
      </div>
    </a>
    <a class="step-item">
      <div class="step-progress">
        <span class="step-count"><i class="czi-idea"></i></span>
      </div>
      <div class="step-label text-dark">
        Deine Bewertung
      </div> 
    </a>
  </div>
  <div class="card-body">
    <div class="tab-content pt-2">
      <div class="tab-pane show active" id="detailTab" role="tabpanel"> 
        <p class="text-center text-dark h5 mb-4 pb-2 mt-1 d-none d-md-block">
          Bitte gib die folgenden Informationen für eine detaillierte Bewertung deiner Küche an.
        </p>
        <p class="text-center text-dark h5 mb-3 pb-2 mt-3 d-md-none">
          Informationen zur Küche für eine detaillierte Bewertung
        </p>
        <div v-for="(detail, idx) in details" :key="idx" class="form-group row align-items-center">
          <label class="col-md-3 col-form-label font-weight-medium" for="select-input">{{detail.name}}</label>
          <div class="col-md-9">
            <select class="form-control custom-select" v-model="detail.selected">
              <option v-for="(opt, id) in detail.options" :key="id" :value="id">
                {{opt}}
              </option>
            </select>
          </div>
        </div>
        <form class="needs-validation" novalidate v-on:submit="formSubmit">
          <div class="form-group row align-items-center">
            <label class="col-md-3 col-form-label font-weight-medium" for="plz-input">Postleitzahl</label>
            <div class="col-md-9">
              <input class="form-control" :v-model="plz" type="tel" id="plz-input" required @input="updatePlz">
              <div class="invalid-feedback">Bitte eine gültige Postleitzahl eingeben.</div>
              <small class="form-text text-muted">Wird für die Logistik benötigt.</small>
            </div>
          </div>
          <div class="form-group row align-items-center">
            <label class="col-md-3 col-form-label font-weight-medium" for="email-input">Email</label>
            <div class="col-md-9">
              <div class="input-group input-group-overlay flex-nowrap">
                <div class="input-group-prepend-overlay">
                  <span class="input-group-text text-muted font-size-base">
                    <i class="czi-mail"></i>
                  </span>
                </div> 
                <input class="form-control prepended-form-control" :v-model="email" @input="updateEmail" type="email" name="EMAIL" id="email-input" required>
              </div> 
              <div class="invalid-feedback">Bitte eine gültige Email-Adresse eingeben.</div>
            </div>
          </div> 
          <div class="form-group row align-items-center">
            <div class="col-md-3"></div>
            <div class="col-md-9">
              <div class="custom-control custom-checkbox py-2 border">
                <input class="custom-control-input" type="checkbox" id="ex-check-1" required>
                <label class="custom-control-label" for="ex-check-1">Ich bin mit dem Erhalt der Bewertung per E-Mail einverstanden</label>
                <div class="invalid-feedback">Ohne diese Zustimmung dürfen wir dir die Bewertung leider nicht zukommen lassen.</div>
              </div>
            </div> 
          </div> 
          <button id="submitBtn" class="btn btn-dark btn-lg btn-shadow" type="submit">Bewertung erhalten <i class="czi-arrow-right ml-2"></i></button>
          <p class="font-size-sm mt-3 px-5">
            Mit Anforderung der Online-Bewertung erklären Sie sich mit der Datenschutzerklärung einverstanden.
          </p>
        </form>
      </div> 
    </div>
  </div>
</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'evaluate',
  components: {
  },
  data () { 
    return {
      details: [
        {name: "Marke", id: "brand", selected: 0,
          options: ["Nicht bekannt / No-Name-Produkt", "Mid-Range", "High-End"]
        },
        {name: "Zustand", id: "condition", selected: 0,
          options: ["Wie Neu", "Übliche Gebrauchsspuren", "Merkliche Beschädigungen"]
        }, 
        {name: "Kühlschrank", id: "fridge", selected: 0,
          options: ["Nicht vorhanden", "No-Name-Produkt", "Mid-Range", "High-End"]
        },
        {name: "Ofen & Herd", id: "oven", selected: 0,
          options: ["No-Name-Produkt", "Mid-Range", "High-End"]
        }, 
        {name: "Spülmaschine", id: "dishwasher", selected: 0,
          options: ["No-Name-Produkt", "Mid-Range", "High-End"]
        },
      ],
      plz: "",
      email: "",
    }
  },
  computed: {
  },
  created: function () {
  },
  mounted: function () {
  },
  watch: {
    progress: function (val) {
      this.progressPct = Math.ceil(val * 33.3);
    }
  },
  methods: {
    formSubmit: function (event) {
      if (event.target.checkValidity() === false) {
        // eslint-disable-line
      } else {
        let kitchenData = {};
        this.details.forEach((el) => {
          kitchenData[el.id] = el.options[el.selected];
          kitchenData[el.id + "ID"] = el.selected.toString();
        }) 
        kitchenData.plz = this.plz;
        kitchenData.email = this.email;
        this.evaluationSubmit(kitchenData);
      }
      
      event.preventDefault();
    },
    updatePlz: function (e) {
      this.plz = e.target.value;
    },
    updateEmail: function (e) {
      this.email = e.target.value;
    }, 
    openProducts: function () {
      this.progress = 2;
      this.$router.push({path: "bewertung"});
    },
    ...mapActions(['evalManagerDispatch']),
    evaluationSubmit: async function (userKitchenData) {
      window.myGTag('event', 'conversion', {'send_to': 'AW-717328684/beCRCOy5rNUBEKyihtYC'});
      await this.evalManagerDispatch({action: "evaluationSubmit", payload: userKitchenData});
    }, 
  }
}
</script>


<style scoped>
.steps-light .step-item.active .step-count,
.steps-light .step-item.active .step-progress {
  background-color:  darkorange ;
}

.steps-dark .step-item.active .step-count,
.steps-dark .step-item.active .step-progress {
  background-color: darkorange;
}
</style>